import React, { useState } from "react";
import moment from "moment";
import { URLS } from "utils/constants";
import useApi from "hooks/useApi";

const exportModule = (moduleId) => {
  const { EXPORT_MODULE } = URLS;
  const api = useApi();
  const [isLoading, setIsLoading] = useState(false);

  const downloadModuleFile = async (cb) => {
    setIsLoading(true);
    const res = await api.get(`${EXPORT_MODULE}/${moduleId}`);
    const fileName = res.data
      ? `${res.data.module_data?.module_name} ${moment().format('YYYY-MM-DD HH-mm-ss')}.hm`
      : `data ${moment().format('YYYY-MM-DD HH-mm-ss')}.hm`;
    try {
      const jsonData = JSON.stringify(res.data || {});
      const blob = new Blob([jsonData], { type: "application/json" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
      cb(true);
    } catch (error) {
      console.error("Error generating zip file:", error);
      cb(false);
    } finally {
      setIsLoading(false);
    }
  };

  return [downloadModuleFile, isLoading];
};

export default exportModule;
